import rootPath from "../routes-path";

export { RouteProps } from "../routes-path";

export const path = "/prispevky";

export default rootPath + path;